import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Short-Term Side Effects';
const pageSubTitle = 'Short-Term Side Effects';
const pageDescription = 'Short-Term Side Effects reflects how important it is to avoid unpleasant effects that may occur shortly after treatment. These may include pain, swelling, fatigue, or other temporary reactions. For example, Physical Therapy tends to score the lowest on short-term side effects, making it a gentler option during early recovery. This criterion helps identify treatments that offer a smoother, more comfortable short-term experience.';
const videoKey = 'scLhuP3-l2M';

const ShortTermSideEffects = () => {

    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={pageDescription}
            videoKey={videoKey}
            pageType="criteria"
        />
    );

};

export default ShortTermSideEffects;